import React, {PropTypes} from "react";
import {Field, reduxForm} from "redux-form";
import {DatePicker, TextField} from "redux-form-material-ui";

const validate = values => {
  const errors = {};
  if (isNaN(values.fatherAge))
    errors.fatherAge = "Enter a number";
  if (isNaN(values.motherAge))
    errors.motherAge = "Enter a number";
  return errors


}

class OtherInfoEdit extends React.Component {

  constructor() {
    super();
  }

  render() {

    const {handleSubmit, reset} = this.props;
    return (
      <div className="col-md-12">
        <form onSubmit={handleSubmit(data=> {
          console.log(data);
          this.props.submitHandler(data);

        })}>
          <table style={{marginBottom: 0, width: '100%'}} className="table table-bordered">
            <thead>
            <tr>
              <th cellPadding="0" colSpan="4">
                <span className="bold pull-left">Other Info</span>
                <span className="bold hrms-link pull-right"><a >
                     <button type="button" onClick={this.props.close}><i className="glyphicon glyphicon-remove"
                     ></i>Cancel</button></a></span>
                <span className="bold hrms-link pull-right"><a>
                    <button type="button" onClick={() => {
                      let resetFields = Object.assign({}, this.props.initialValues, {
                        bloodGroup: '',
                        nationality: '',
                        height: '',
                        weight: '',
                        fatherAge: '',
                        motherAge: '',
                        spouseDOB: null,
                        child1DOB: null,
                        child2DOB: null
                      });
                      this.props.initialize(resetFields);
                    }}><i className="glyphicon glyphicon-refresh"
                    ></i>Clear Values</button></a></span>
                <span className="bold hrms-link pull-right"><a type="submit">
                     <button type="submit"><i className="glyphicon glyphicon-saved"
                     ></i>Save</button></a></span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td style={{align: 'left', width: '18%'}}>BloodGroup :</td>
              <td style={{align: 'left', width: '28%', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtName" className="GenText">
                    <Field
                      name="bloodGroup"
                      component={TextField}/></span>
              </td>
              <td style={{align: 'left', width: '18%'}}>Nationality :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtSpouseName" className="GenText">
                     <Field
                       name="nationality"
                       component={TextField}
                     />
                  </span>
              </td>
            </tr>
            <tr>
              <td style={{align: 'left'}}>Height :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblDOB" className="GenText"><Field
                    hintText="In Centimetres"
                    name="height"
                    component={TextField}/></span>
              </td>
              <td style={{align: 'left'}}>Weight :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblAnniversary" className="GenText">
                    <Field
                      hintText="In Kilograms"
                      name="weight"
                      component={TextField}/></span>
              </td>
            </tr>

            <tr>
              <td style={{align: 'left'}}>Father Age :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                    <Field
                      name="fatherAge"
                      component={TextField}/></span>
              </td>
              <td style={{align: 'left'}}>Mother Age :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblAnniversary" className="GenText">
                    <Field
                      name="motherAge"
                      component={TextField}/></span>
              </td>
            </tr>

            <tr>
              <td style={{align: 'left'}}>Spouse DOB:</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                    <Field

                      name="spouseDOB"
                      autoOk="true"
                      component={DatePicker}/>
                  </span>
              </td>
              <td style={{align: 'left'}}>Child 1 DOB :</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblAnniversary" className="GenText"><Field
                    name="child1DOB"
                    autoOk="true"
                    component={DatePicker}/></span>
              </td>
            </tr>
            <tr>
              <td style={{align: 'left'}}>Child 2 DOB:</td>
              <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_lblDOB" className="GenText">
                    <Field
                      name="child2DOB"
                      autoOk="true"
                      component={DatePicker}/>
                  </span>
              </td>
            </tr>
            </tbody>
          </table>
        </form>


      </div>
    );
  }
}

OtherInfoEdit.propTypes = {};

export default reduxForm({
  form: 'otherInfo',
  validate


})(OtherInfoEdit)






/** WEBPACK FOOTER **
 ** ./src/feature/myProfile/EmployeeSS/Tables/OtherInfoEdit.js
 **/